import React, { ReactElement } from 'react';
import { BaseHeadline } from './base-headline';
import { HeadlineProps } from './headline.types';

export function Headline(props: HeadlineProps): ReactElement {
	return <BaseHeadline {...props} />;
}
